import { formatNumber } from '@/utils/number';
import {
  INSTITUTE_CATEGORY_LABELS,
  INSTITUTE_LEVEL_LABELS,
} from '../constants/instituteSubmission.constants';
import type { InstituteValues } from '../types/instituteSubmission.types';

const CLASS_NAME_SEPARATOR = ', ';

export function toInstituteDisplayValue(
  values: InstituteValues,
  key: keyof InstituteValues,
): string | null {
  if (key === 'instituteCategory') {
    return values.instituteCategory ? INSTITUTE_CATEGORY_LABELS[values.instituteCategory] : null;
  }
  if (key === 'instituteLevel') {
    return values.instituteLevel ? INSTITUTE_LEVEL_LABELS[values.instituteLevel] : null;
  }
  if (key === 'academicClasses') {
    if (values.academicClasses.length === 0) return null;
    return values.academicClasses
      .map((academicClass) => academicClass.name)
      .join(CLASS_NAME_SEPARATOR);
  }
  if (key === 'totalStudents') {
    return values.totalStudents === null ? null : formatNumber(values.totalStudents);
  }
  if (key === 'purchasePercentage') {
    return values.purchasePercentage === null ? null : `${values.purchasePercentage}%`;
  }
  return values[key];
}
